import { decode as base64_decode, encode as base64_encode } from 'base-64';
import RootStore from './RootStore';
import { postApi,baseURL } from '../components/Utility'
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
} from 'mobx';
import { act } from 'react-dom/test-utils';
import config from '../config';

class FuelConsumptionReportStore {
  loading=false
  fuelconsumptionReport = []
  getDrivers=[]
  rootStore

  constructor(rootStore) {
    makeObservable(this, {
      fuelconsumptionReport: observable,
      loadData: action,

    });
    this.rootStore = rootStore;

  }



  async loadData({ companyId,vehicleId,offset, limit,driverId,fromDate,toDate,pageNo }) {
    this.loading=true
    // console.log("vehicle list")
    var postData = { "companyId": companyId, "vehicleId": vehicleId, "driverId": driverId, "fromDate": fromDate, "toDate": toDate, "offset": offset,"limit":limit, "page":pageNo }

    const base64Input = await base64_encode(JSON.stringify(postData));
    if(config.pythonReport==1){
       var response = await postApi
        .getClient("report")
        .post("/fleet_report/fuelconsumption", postData);
    }
   
    
    this.fuelconsumptionReport = response?.data?.data?.fuelconsumption
    this.total = response?.data?.data?.TotalCount
    this.loading=false
  }

  async getDriversByCompanyId({companyId}){
    var postData = {companyId:companyId}
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi.getClient().post("index.php?c=driver&a=getdatabycompany", "postData=" + base64Input);
    console.log(response, "post")
    this.getDrivers =response?.data?.data
    return response?.data?.data
  }

  

  async exportExcel(getData) {
     if (config.pythonReport === 1) {
      try {
        await postApi.getClient("report").post("/fleet_report/fuelconsumption/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }
    }
  }


  async exportpdf(getData) {
    let lang = "english";
    if (config.pythonReport === 1) {
      try {
        await postApi.getClient("report").post("/fleet_report/fuelconsumption/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
      } catch (error) {
        this.pythonReportErrorMessage = true;
      }
    
  }
  }

  // async exportcsv(getData) {
  //   let lang = "english";
  //   window.location.href =
  //     baseURL +
  //     "index.php?c=vehicle&a=exportfuelrepcsv&cid=" +
  //     getData.companyId +
  //     "&userId=" +
  //     getData.userId +
  //     "&vid=" +
  //     getData.vehicleId +
  //     "&did="+
  //     getData.DriverId+
  //     "&fD=" +
  //     getData.fromDate +
     
  //     "&tD=" +
  //     getData.toDate +
  //     "&colList=" +
  //     getData.colList +
  //     "&language=" +
  //     lang;
  // }
  // async exportxml(getData) {
  //   let lang = "english";
  //   window.location.href =
  //     baseURL +
  //     "index.php?c=vehicle&a=exportfuelrepxml&cid=" +
  //     getData.companyId +
  //     "&userId=" +
  //     getData.userId +
  //     "&vid=" +
  //     getData.vehicleId +
  //     "&did="+
  //     getData.DriverId+
  //     "&fD=" +
  //     getData.fromDate +
     
  //     "&tD=" +
  //     getData.toDate +
  //     "&colList=" +
  //     getData.colList +
  //     "&language=" +
  //     lang;
  // }
}

export default FuelConsumptionReportStore;
